<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <formEdit :key="componentKey" :mode="mode" @back="backToList" @save="saveData" :triggerSave.sync="triggerSave"
          :model="models" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add_promotion'
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'News', to: '/admin/list-news' },
        { label: '' }
      ],
      validationErrors: [],
      title: "Create A New News Promotion",
      mode: 'add_promotion',
      models: {},
      componentKey: 1,
      page_transaction: null,
      time_zone_local: moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted() {
    this.mode = this.$route.name === 'edit_promotion' ? 'edit_promotion' : this.mode;
    this.title = this.mode === 'edit_promotion' ? 'Edit' : this.title;
    this.items_bread_crumb[1].label = this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_NEWS);
    if (this.mode == 'edit') {
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    } else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    }
    this.componentKey = (new Date()).getTime();
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-news' });
    },
    tringToSlug(str) {
      return str
        .toLowerCase()
        .trim()
        .replace(/[\s\W-]+/g, '-')
        .replace(/^-+|-+$/g, '');
    },
    async saveData(params) {
      var list_file = params?.list_file ?? [];
      var list_file_edit = params?.list_file_edit ?? [];
      var list_id_file_delete = params?.list_id_file_delete ?? [];
      let objects = {};
      this.triggerSave = false;
      if (this.mode === 'add_promotion') {
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        try {
          let resNews = await this.$apollo.mutate({
            mutation: DataServices.insertData('news'),
            variables: {
              objects: {
                name: params?.name ?? "",
                alt: params?.alt ?? "",
                news_category_id: params?.news_category_id ?? "",
                short_description: params?.short_description ?? "",
                description: params?.description ?? "",
                url_video: params?.url_video ?? "",
                ordinal: params?.ordinal ?? 0,
                website: params?.website ?? true,
                app: params?.app ?? true,
                active: true,
                slug: this.tringToSlug(params?.name ?? ""),
                type: params?.type ?? 1,
                updated_at: moment.tz(new Date(), this.time_zone_local),
                created_by: this.$store.getters.user,
              },
            }
          });
          let returningNews = resNews.data[Object.keys(resNews.data)].returning[0];
          // Upload ảnh bìa nếu có
          if (list_file.length > 0) {
            let resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.NEWS_AVARTAR, list_file);
            if (resImage && resImage.length > 0) {
              for (let i = 0; i < resImage.length; i++) {
                let objectImage = resImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.NEWS_AVARTAR, returningNews.id, objectImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }
          try {
            let slug = this.tringToSlug(params?.name ?? "");
            await ApiRepository.post('/_api/sitemap/add_sitemap', {
              url: `promotions/${slug}`,
              type: 'dynamic',
              obj_id: returningNews.id,
              priority: 0.5,
              changefreq: 'weekly',
              lastmod: moment.tz(new Date(), this.time_zone_local).format('YYYY-MM-DD HH:mm:ss'),
              uid_admin: this.$store.getters.user
            });
          } catch (error) {
            console.log('Error adding to sitemap:', error);
          }

          this.redirectEdit();
        } catch (error) {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
          this.$commonFuction.is_loading(false);
        }
      } else if (this.mode === 'edit_promotion') {
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        try {
          let resNews = await this.$apollo.mutate({
            mutation: DataServices.updateData('news'),
            variables: {
              'data_update': {
                name: params?.name ?? "",
                alt: params?.alt ?? "",
                news_category_id: params?.news_category_id ?? "",
                short_description: params?.short_description ?? "",
                description: params?.description ?? "",
                url_video: params?.url_video ?? "",
                ordinal: params?.ordinal ?? 0,
                website: params?.website ?? true,
                app: params?.app ?? true,
                active: true,
                slug: this.tringToSlug(params?.name ?? ""),
                type: params?.type ?? 1,
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
              },
              'where_key': {
                'id': { '_eq': this.models.id }
              }
            }
          });

          let returningNews = resNews.data[Object.keys(resNews.data)].returning[0];

          try {
            let slug = this.tringToSlug(params?.name ?? "");
            await ApiRepository.post('/_api/sitemap/add_sitemap', {
              url: `promotions/${slug}`,
              type: 'dynamic',
              obj_id: returningNews.id,
              priority: 0.5,
              changefreq: 'weekly',
              lastmod: moment.tz(new Date(), this.time_zone_local).format('YYYY-MM-DD HH:mm:ss'),
              uid_admin: this.$store.getters.user
            });
          } catch (error) {
            console.log('Error adding to sitemap:', error);
          }

          if (list_id_file_delete.length > 0) {
            await this.$CoreService.deleteDataImageMulti(this.$constants.TYPE_IMAGE.NEWS_AVARTAR, list_id_file_delete)
          }

          if (list_id_file_delete.length > 0) {
            await this.$CoreService.deleteDataImage(this.$constants.TYPE_IMAGE.NEWS_AVARTAR, returningNews.id);
          }

          if (list_file.length > 0) {
            if (list_file_edit.length > 0) {
              await this.$CoreService.deleteDataImage(this.$constants.TYPE_IMAGE.NEWS_AVARTAR, this.models.id);
            }
            const resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.NEWS_AVARTAR, list_file);
            if (resImage && resImage.length > 0) {
              for (let i = 0; i < resImage.length; i++) {
                var image = resImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.NEWS_AVARTAR, returningNews.id, image).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }
          this.redirectEdit();
        } catch (error) {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
        }
      }

      this.$commonFuction.is_loading(false);
    },
    async redirectEdit() {
      var that = this;
      var router_back = { path: '/admin/list-news' };
      that.$commonFuction.is_loading(false);
      if (that.mode == 'add_promotion') {
        that.$router.push(router_back);
      } else {
        if (!that.$commonFuction.isEmpty(router_back)) {
          // that.page_transaction = ""+that.page_transaction
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var { data } = await this.$apollo.query({
        query: DataServices.getList('news'),
        variables: {
          where_key: {
            id: { '_eq': id }
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        try {
          var dataImage = await this.$CoreService.getFileMapFile([this.$constants.TYPE_IMAGE.NEWS_AVARTAR], [this.models.id]);
          this.models["list_file_edit"] = dataImage.listData;
        } catch (error) {
          console.log('error function', error);
        }
      }
      this.componentKey++;
    },
  },
}
</script>

<style lang="scss">
.manager-title-custom {
  color: #1D3118;
  font-size: 24px !important;
  /* margin-bottom: 16px; */
  padding-bottom: 20px;
  /* border-bottom: 1px solid #EEEEEE; */
  font-weight: 700;
  margin-left: 20px;
}

.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only {
      padding: 0 !important;
    }
  }
}

.note {
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 24px;
  padding-top: 10px;
}

.p-formgrid {
  margin: 0;

  .p-panel-header {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
    background: #EEEEEE;
  }

  .p-card-field {
    padding: 24px;

    .p-field {
      .p-col-fixed {
        width: 300px;
        display: inline-block !important;
        margin: 0;
      }

      .p-col-width {
        width: 500px !important;
        border-radius: 5px;

        &.disabled {
          background: #EEEEEE;
          border: 0 none;
          padding: 8px 10px;
        }

        .file-select {
          margin: 0;

          input[type="file"] {
            display: none;
          }

          .select-button {
            display: inline-block;
            cursor: pointer;
            background: transparent;
            border-radius: 5px;
            color: #000000;
            font-size: 13px;
            padding: 3px 16px;
            border: 1px solid #B4B4B4;
          }
        }

        &.pac-target-input {
          height: 80px;
          word-break: break-all;
          overflow-wrap: break-word;
          resize: none;
        }
      }

      .box-images {
        margin: 0;
        margin-top: 10px;
        position: relative;

        .item-img {
          width: 150px;
          height: 150px;
          margin-right: 8px;
          margin-bottom: 8px;
          display: inline-flex;
          position: relative;

          img {
            max-width: 100%;
            height: auto;
            margin: 0 auto;
            object-fit: contain;
            padding: 5px;
          }

          .button-clear {
            border-radius: 10px;
            width: 24px;
            height: 24px;
            background: #F5564E;
            float: right;
            cursor: pointer;
            position: absolute;
            right: 0px;

            img {
              vertical-align: top;
            }
          }
        }
      }

      .p-invalid {
        display: block;
      }
    }
  }

  .fixed-bottom-toolbar {
    background: transparent;
    border: 0 none;
    margin-top: 22px;
    border-top: 1px solid #B4B4B4;
    padding: 0;
    padding-top: 30px;

    .p-button {
      width: auto;
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.manager-title-row {
  border-bottom: 1px solid #EEEEEE;
}

.p-toolbar-group-right {
  flex-basis: 30%;
}

.p-button-warning.p-button {
  margin: 0 10px;
}
</style>
